var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['configuration/crmCallPhonePath'])?_c('a',{attrs:{"href":_vm.$store.getters['configuration/crmCallPhonePath'].replace('%phoneNumber%', _vm.phoneNumber),"target":"_blank"}},[_vm._v(_vm._s(_vm.phoneNumber))]):_c('span',[_vm._v(_vm._s(_vm.phoneNumber))])
}
var staticRenderFns = []

export { render, staticRenderFns }